export interface ISearchResultResponse {
  results: ISearchResult[];
  facets: IFacets;
  totalResults: number;
  trackingId: string;
  hasRestrictedResults: boolean;
}

export interface ISearchResult {
  title: string;
  url: string;
  description: string;
  hitId: string;
  isBestBet: string;
  contentType: ContentTypeEnum;
  contentTypeText: string;
  authors: string[];
  date: string;
  imageUrl: string;
  imageAltText: string;
  titleNoHtml: string;
}

export enum ContentTypeEnum {
  Default,
  Article,
  Guide,
  Playlist,
  Podcast,
  Audio,
  Event,
  Store,
  SiteContent,
  PressRelease,
  Marketing,
  Video,
}

export interface IFacets {
  facets: IFacet[];
}

export interface IFacet {
  fieldName: string;
  displayName: string;
  facetDisplayOption: FacetDisplayOption;
  terms: ITerm[];
}

export interface ITerm {
  id: string;
  displayName: string;
  fieldName: string;
  term: string;
  hits: number;
  selected: boolean;
}

export enum FacetDisplayOption {
  Checkbox,
}

export interface ISearchRequest {
  SearchTerm: string;
  PageSize: number;
  PageNumber: number;
  Filters: IFilterRequest[];
  Language: string;
}

export interface IFilterRequest {
  fieldName: string;
  terms: string[] | undefined;
}

export interface IAutocompleteResponse {
  hits: IAutocompleteHit[];
}

export const DefaultAutoCompleteResults: IAutocompleteResponse = Object.freeze({
  hits: [],
});

export interface IAutocompleteHit {
  query: string;
  type: string;
}

export interface ISearchResultClickRequest {
  searchTerm: string;
  trackingId: string;
  hitId: string;
}

export interface ISearchContentResponse {
  heading: string;
  searchBarPlaceholder: string;
  clearButtonLabel: string;
  searchButtonLabel: string;
  pageNumbersText: string;
  pageButtonLabel: string;
  nextButtonLabel: string;
  filtersLabel: string;
  contentTypeFilterLabel: string;
  yearFilterLabel: string;
  contentSourceFilterLabel: string;
  topicsFilterLabel: string;
  articleResultLabel: string;
  playlistResultLabel: string;
  videoResultLabel: string;
  podcastResultLabel: string;
  audioResultLabel: string;
  guideResultLabel: string;
  eventResultLabel: string;
  marketingResultLabel: string;
  pressReleaseResultLabel: string;
  siteContentResultLabel: string;
  storeResultLabel: string;
  noResultsText: string;
  errorResultsText: string;
  clearAllLabel: string;
  searchPageUrl: string;
  thumbnailPlaceholder: string;
  restrictedContentText: string;
}
